<div class="loading">
    <div *ngFor="let bullet of bullets"></div>
</div>
